import {type FeatureFlag} from '../../@type/features';
import {type PeachPayCheckoutData} from './types';

declare const peachpay_checkout_data: PeachPayCheckoutData;

const Feature = {
	enabled(flag: FeatureFlag): boolean {
		return peachpay_checkout_data.plugin.feature_support[flag]?.enabled ?? false;
	},
	metadata<T>(flag: FeatureFlag, key: string, defaultValue: T | null = null): T | null {
		return peachpay_checkout_data.plugin.feature_support[flag]?.metadata[key] ?? defaultValue;
	},
};

export {Feature};
